<template>
  <div>
    <div class="bind_preamble_box">
      <div class="form_item">
        <p>{{ $t('home.yinjicode') }}</p>
        <input type="text"
               v-model="preamble_code"
               :placeholder="$t('preamble.tx5')">
      </div>
      <div class="form_item">
        <p>{{$t('preamble.tx6')}} <span>{{$t('preamble.tx7')}}</span></p>
        <input type="text"
               v-model="password"
               :placeholder="$t('preamble.tx8')">
      </div>
      <li class="form_item form_submit"
          @click="getSearch"
          ref='form_submit'>
        {{$t('toast.comfirmBtn1')}}
      </li>
    </div>
  </div>
</template>

<script>
import { preamble_code_check } from '@/api/login'
import { getSessionStorage, setSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      preamble_code: '',
      password: '',
      flag: false,
    }
  },
  methods: {
    getSearch() {
      if (this.flag) return
      this.flag = true
      setTimeout(() => {
        this.flag = false
      }, 1500)
      const accountStorage = JSON.parse(getSessionStorage('preambleInfo'))
      if (accountStorage.access_token) {
        const preamblecode = JSON.parse(getSessionStorage('preamblecode'))
        if (this.preamble_code == preamblecode.preamble_code) {
          this.$toast(this.$t('preamble.tx9'))
          return
        }
      }
      this.getInfo()
    },
    getInfo() {
      const configData = JSON.parse(getSessionStorage('message'))
      const playInfo = {
        password: this.password,
        preamble_code: this.preamble_code,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(configData)),
        playInfo
      )
      setSessionStorage('playInfo', JSON.stringify(playInfo))
      preamble_code_check(msg).then((res) => {
        setSessionStorage('userInfo', JSON.stringify(res.data.list))
        this.$router.push({ path: '/infoPreamble' })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.bind_preamble_box {
  width: 100%;
  padding: 30/75rem;
  .form_item {
    p {
      width: 630/75rem;
      font-weight: bold;
      font-size: 28/75rem;
      color: #575757;
      margin-bottom: 10/75rem;
      span {
        font-size: 20/75rem;
        color: #959595;
      }
    }
    input {
      border: 1px solid #575757;
      outline: none;
      width: 610/75rem;
      height: 79/75rem;
      display: block;
      margin-left: 20/75rem;
      border-radius: 6/75rem;
      font-size: 25/75rem;
      text-indent: 15/75rem;
      margin-bottom: 40/75rem;
    }
  }
}
</style>